import { render, staticRenderFns } from "./HeadSearch.vue?vue&type=template&id=6b4ed79d&scoped=true"
import script from "./HeadSearch.vue?vue&type=script&lang=js"
export * from "./HeadSearch.vue?vue&type=script&lang=js"
import style0 from "./HeadSearch.vue?vue&type=style&index=0&id=6b4ed79d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ed79d",
  null
  
)

export default component.exports